import { useNavigate } from "react-router-dom";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { getSubmissionOutcome } from "utils/immunizationStatus";
import { pathGenerators } from "utils/routes";

import style from "./PpsnClaimBlockedDialog.module.css";

/**
 * "Reported to NIIS, but nobody will be paid for it."
 *
 * A dialog rather than a toast: this is the one submission outcome that needs a person,
 * and a toast is missable — which is the failure this exists to close, not one to
 * reintroduce more quietly (KIN-1789). Shared once a second screen could submit
 * (KIN-1820).
 */
export const PpsnClaimBlockedDialog = ({ patientId, onClose }) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={!!patientId}
      title="Reported to NIIS — no claim sent"
      onClose={onClose}
      width={520}
    >
      <div className={style.body}>
        <p className={style.text}>
          {getSubmissionOutcome("VACCINATION_REPORT_ONLY_NOT_CLAIMABLE").message}
        </p>
        <div className={style.actions}>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button
            onClick={() => {
              onClose();
              navigate(pathGenerators.patient.details(patientId));
            }}
          >
            Open patient record
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
